/**
 * Opens a route or an url in the same tab.
 *
 * @param {Gaia.Web.Application} app - web application reference
 * @returns {function(...[*])}
 */
const open = app => ({ url, params }) => {
  const target = new URL(url)
  target.search = new URLSearchParams(params).toString()

  window.location.href = target.href
}

export default open
